<template>
	<v-dialog
		v-model="dialog"
		max-width="960px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<template
			v-if="
				inventory_type !== 'product_order_individual_info' &&
				inventory_type !== 'wip_order_individual_info'
			"
			v-slot:activator="{ on, attrs }"
		>
			<v-btn
				:text="text"
				:color="text ? 'white' : 'secondary'"
				class="ml-2"
				v-bind="attrs"
				v-on="on"
			>
				<v-icon class="mr-1">mdi-plus</v-icon>
				棚卸し項目追加
			</v-btn>
		</template>

		<v-card tile>
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">棚卸し項目追加</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark @click="closeDialog" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>
			<v-sheet elevation="0">
				<!-- ここから初期の検索 -->
				<v-form ref="form" class="pa-2">
					<v-row v-if="inventory_type == 'component'" no-gutters>
						<v-col class="p-auto-1" cols="12" sm="6">
							<v-text-field v-model="q.name" label="部品名" class="mt-4" outlined dense />
						</v-col>
						<v-col class="p-auto-1" cols="12" sm="6">
							<v-text-field v-model="q.part_number" label="部品番号" class="mt-4" outlined dense />
						</v-col>
					</v-row>
					<v-row v-if="inventory_type == 'rubber'" no-gutters>
						<v-col class="p-auto-1" cols="12" sm="6">
							<v-text-field v-model="q.name_cont" label="中間物名" class="mt-4" outlined dense />
						</v-col>
						<v-col class="p-auto-1" cols="12" sm="6">
							<v-select
								v-model="q.rubber_type_id_eq"
								:items="select_items.rubber_types"
								item-text="name"
								item-value="id"
								label="中間物の種類"
								class="mt-4"
								outlined
								dense
							/>
						</v-col>
					</v-row>
					<v-row v-if="inventory_type == 'material'" no-gutters>
						<v-col class="p-auto-1" cols="12" sm="6">
							<v-text-field v-model="q.name_cont" label="原材料名" class="mt-4" outlined dense />
						</v-col>
						<v-col class="p-auto-1" cols="12" sm="6">
							<v-select
								v-model="q.material_category_id_eq"
								:items="select_items.material_categories"
								item-text="name"
								item-value="id"
								label="原材料の種類"
								class="mt-4"
								outlined
								dense
							/>
						</v-col>
					</v-row>
					<v-row v-if="inventory_type == 'paint'" no-gutters>
						<v-col class="p-auto-1" cols="12" sm="6">
							<v-text-field v-model="q.name_cont" label="塗料名" class="mt-4" outlined dense />
						</v-col>
					</v-row>
					<v-row no-gutters justify="center">
						<v-btn color="secondary" @click="searchItems(1)">
							<v-icon class="mr-1">mdi-magnify</v-icon>
							検索
						</v-btn>
					</v-row>
				</v-form>

				<!-- ここからテーブル選択 -->
				<div class="pa-2" v-if="showTable">
					<v-divider class="mt-4" />
					<div class="table-container mt-4">
						<v-data-table
							locale="ja-JP"
							:items="items"
							:headers="itemHeaders"
							:mobile-breakpoint="240"
							hide-default-footer
							disable-filtering
							disable-pagination
							disable-sort
							@click:row="setSelectedItem"
							no-data-text="データがありません。"
						>
							<!-- <template v-slot:item="{ item }">
								<tr class="clickable" @click="setSelectedItem(item)">
									<td></td>
								</tr>
							</template> -->
						</v-data-table>
						<v-menu v-model="confirmMenu" :position-x="x" :position-y="y" absolute offset-y>
							<v-list>
								<v-list-item @click="selectData">
									<v-list-item-title>棚卸し対象に追加する</v-list-item-title>
								</v-list-item>
							</v-list>
						</v-menu>
					</div>
					<PaginationModule :pagination="pagination" @get-page="searchItems($event)" />
				</div>
				<div class="pa-2" v-if="selectedItems.length">
					<v-divider class="my-4" />
					<h6 class="text-body-1 font-weight-bold">棚卸し追加対象</h6>
					<v-row no-gutters>
						<v-col
							class="pa-2"
							v-for="selectedItem in selectedItems"
							:key="`selected-${selectedItem.item.id}`"
							sm="6"
							lg="4"
							cols="12"
						>
							<!-- TODO それぞれのカード -->
							<v-card
								class="pa-2"
								v-if="
									inventory_type == 'product_order_individual_info' ||
									inventory_type == 'wip_order_individual_info'
								"
							>
								<v-row no-gutters justify="space-between">
									<p class="text-body-2">
										製品名：{{ selectedItem.item.ordered_product.product.name }}<br />
										製造番号：{{ selectedItem.item.ordered_product.product_number }}
									</p>
									<v-btn icon @click="removeSelectedItem(selectedItem)">
										<v-icon>mdi-delete</v-icon>
									</v-btn>
								</v-row>
								<v-text-field
									v-model="selectedItem.item.quantity"
									label="個数"
									class="mt-4"
									outlined
									dense
									type="number"
								/>
							</v-card>
							<v-card class="pa-2" v-if="inventory_type == 'component'">
								<v-row no-gutters justify="space-between">
									<p class="text-body-2">
										部品名：{{ selectedItem.item.name }}<br />部品番号：{{
											selectedItem.item.part_number
										}}<br />ワイルドカード：{{ selectedItem.item.handle_wildcard }}
									</p>
									<v-btn icon @click="removeSelectedItem(selectedItem)">
										<v-icon>mdi-delete</v-icon>
									</v-btn>
								</v-row>
								<v-row no-gutters>
									<v-text-field
										v-model="selectedItem.item.stock"
										label="個数"
										class="mt-4"
										outlined
										dense
										type="number"
									/>
									<template v-if="selectedItem.item.wildcard">
										<!-- TODO インクリメンタルで絞り込みに変更 -->
										<v-autocomplete
											v-model="selectedItem.item.ordered_product"
											label="製造番号"
											class="mt-4"
											outlined
											dense
											:items="selectedItem.item.find_order_components_with_ordered_product"
											item-value="order_component.ordered_product.product_number"
											item-text="order_component.ordered_product.product_number"
										/>
										<v-text-field
											v-model="selectedItem.item.unit_price"
											label="単価"
											class="mt-4"
											outlined
											dense
											type="number"
											suffix="円"
										/>
									</template>
								</v-row>
							</v-card>
							<v-card class="pa-2" v-if="inventory_type == 'rubber'">
								<v-row no-gutters justify="space-between">
									<p class="text-body-2">ゴム生地名：{{ selectedItem.item.name }}</p>
									<v-btn icon @click="removeSelectedItem(selectedItem)">
										<v-icon>mdi-delete</v-icon>
									</v-btn>
								</v-row>
								<v-text-field
									v-model="selectedItem.item.stock"
									label="個数"
									class="mt-4"
									outlined
									dense
									type="number"
								/>
							</v-card>
							<v-card class="pa-2" v-if="inventory_type == 'material'">
								<v-row no-gutters justify="space-between">
									<p class="text-body-2">原材料名：{{ selectedItem.item.name }}</p>
									<v-btn icon @click="removeSelectedItem(selectedItem)">
										<v-icon>mdi-delete</v-icon>
									</v-btn>
								</v-row>
								<v-text-field
									v-model="selectedItem.item.stock"
									label="個数"
									class="mt-4"
									outlined
									dense
									type="number"
								/>
							</v-card>
							<v-card class="pa-2" v-if="inventory_type == 'paint'">
								<v-row no-gutters justify="space-between">
									<p class="text-body-2">塗料名：{{ selectedItem.item.name }}</p>
									<v-btn icon @click="removeSelectedItem(selectedItem)">
										<v-icon>mdi-delete</v-icon>
									</v-btn>
								</v-row>
								<v-text-field
									v-model="selectedItem.item.stock"
									label="個数"
									class="mt-4"
									outlined
									dense
									type="number"
								/>
							</v-card>
						</v-col>
					</v-row>
				</div>
			</v-sheet>
			<v-card-actions>
				<v-row no-gutters class="pb-2">
					<v-col sm="4" cols="0" />
					<v-col sm="4" cols="12">
						<v-row v-if="showTable" no-gutters justify="center">
							<v-btn color="secondary" @click="submitForm" :disabled="!isValid">
								<v-icon class="mr-2">mdi-plus</v-icon>
								追加する
							</v-btn>
						</v-row>
					</v-col>
					<v-col sm="4" cols="0" v-if="!$vuetify.breakpoint.xs">
						<v-row no-gutters justify="end">
							<v-btn color="grey darken-1" text @click="closeDialog"> 閉じる </v-btn>
						</v-row>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import Qs from "qs"
import rules from "../../../helper/rules"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import PaginationModule from "../../../modules/PaginationModule.vue"

export default {
	props: {
		text: Boolean,
		inventory_type: {
			type: String,
			required: true,
		},
		select_items: {
			type: Object,
			required: true,
		},
	},
	components: {
		PaginationModule,
	},
	data() {
		return {
			q: {},
			itemHeaders: [],
			items: [],
			selectedItems: [],
			selectedItem: null,
			showTable: false,
			confirmMenu: false,
			x: 0,
			y: 0,

			dialog: false,
			rules: rules,
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
		}
	},
	mounted() {
		switch (this.inventory_type) {
			case "component":
				this.q = {
					name: null,
					part_number: null,
				}
				this.itemHeaders = [
					{ text: "部品名", value: "name", width: "100px" },
					{ text: "部品番号", value: "part_number", width: "100px" },
					{ text: "ワイルドカード", value: "handle_wildcard", width: "100px" },
				]
				break
			case "rubber":
				this.q = {
					rubber_type_id_eq: this.rubber_type_id_eq,
				}
				this.itemHeaders = [{ text: "ゴム生地名", value: "name", width: "100px" }]
				break
			case "material":
				this.q = {
					name_cont: null,
				}
				this.itemHeaders = [{ text: "原料名", value: "name", width: "100px" }]
				break
			case "paint":
				this.q = {
					name_cont: null,
				}
				this.itemHeaders = [{ text: "塗料名", value: "name", width: "100px" }]
				break
		}
	},
	methods: {
		searchItems(page) {
			const headers = authenticate.setHeader()
			const params = { page: page, q: this.q, inventory_type: this.inventory_type }
			const paramsSerializer = (params) => Qs.stringify(params, { arrayFormat: "brackets" })

			axios
				.get("/erp/v1/inventories/search_items", {
					params,
					paramsSerializer,
					headers,
				})
				.then((response) => {
					this.showTable = true
					this.items = response.data.items
					this.pagination = response.data.pagination
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		setSelectedItem(item) {
			this.selectedItem = { item } // TODO オブジェクトではなくそのままitemを渡す
			this.confirmMenu = false
			this.x = event.clientX
			this.y = event.clientY
			this.$nextTick(() => {
				this.confirmMenu = true
			})
		},
		selectData() {
			this.selectedItems.push(this.selectedItem)
			this.selectedItem = null
			this.confirmMenu = false
		},
		submitForm() {
			this.$emit("add-item", this.selectedItems)
			this.closeDialog()
		},
		resetForm() {
			this.$refs.form.reset()
		},
		resetCard() {
			this.selectedItems = []
		},
		removeSelectedItem(selected_item) {
			this.selectedItems = this.selectedItems.filter(
				(selectedItem) => selectedItem.item.id !== selected_item.item.id
			)
		},
		closeDialog() {
			this.resetForm()
			this.resetCard()
			this.items = []
			this.dialog = false
		},
	},
	computed: {
		isValid() {
			return true
			//   Todo
			// switch (this.inventory_type) {
			// 	case "component":
			// 		break
			// }
		},
	},
}
</script>

<style lang="scss" scoped>
.products {
	.row {
		&:not(:first-child) {
			border-top: 1px solid whitesmoke;
		}
	}
}
</style>
